// extracted by mini-css-extract-plugin
module.exports = {"page":"CartResult_page__HJ6vV","text":"CartResult_text__xKTZn","title":"CartResult_title__3-xD1","desc":"CartResult_desc__1t0MA"};